import { InjectionToken, Type } from "@angular/core";
import { NotificationServiceBase } from "./notification-service.base";

export const ROOT_SERVICE = new InjectionToken<Type<NotificationServiceBase>>(
  '@avano-components/avano-notifications Internal Root Service'
)

export const _ROOT_SERVICE = new InjectionToken<Type<NotificationServiceBase>>(
  '@avano-components/avano-notifications Root Service'
)
